export default __webpack_public_path__ + "static/media/kitchen3-afterJ-1024w.93ba7a50.webp";